import React from "react";

const CheckboxInput = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    primaryLabel,
    error,
    baseinfo,
    formInput,
    defaultValue,
  } = props;
  const { name, validation } = formInput;
  return (
    <div className={`my-4 ${containerCls}`}>
      {primaryLabel ? (
        <div>
          <hr /> <div className="pb-1 my-8 text-gray-800">{primaryLabel}</div>
        </div>
      ) : null}
      <input
        name={name}
        type="checkbox"
        defaultValue={defaultValue}
        {...inputProps}
      />
      {label ? (
        <span className="pb-1 text-gray-800 incident_checkbox">{label}</span>
      ) : null}
      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default CheckboxInput;
